import styled from 'styled-components';

const Heading = styled.div`
  display: flex;
  align-items: center;
  height: ${({ isDesktop }) => (isDesktop ? '40px' : '51px')};
  padding: ${({ isDesktop, isFirst }) => (isDesktop ? (isFirst ? '5px 0 0 0' : '5px 0') : '15px 2% 15px 12px')};
  ${({ isDesktop }) => (isDesktop ? 'border-bottom: solid 2px #000' : null)};
  ${({ isDesktop }) => (isDesktop ? 'margin-bottom: 10px' : null)};
  color: #000;
  user-select: none;
  cursor: pointer;
`;

export default Heading;
